module.exports = __webpack_public_path__ + "static/media/menu-open-white.40a8d1b2.svg";